const listingLogsTransformer = response => {
  return response.map(e => {
    return {
      ...e,
      unitInfo: [
        e.unitNumber ? e.unitNumber : "",
        e.Type.name ? e.Type.name : "",
        e.bed ? e.bed : "",
      ],
    }
  })
}
export default listingLogsTransformer
